<div class="flex justify-between">
  <div class="inline-flex items-center">
    <span class="text-base font-medium">{{data.selectedRecords}} 
      {{ data.module === 'PPM' ? getSnackBarContent() : (getSnackBarContent() | titlecase) }}
    </span>
  </div>
  <div class="flex items-center ml-10">
    <ng-container *ngFor="let action of data.actionButton">
      <button mat-stroked-button class="inline-flex items-center mr-2 px-3 py-2 h-7 actionButton text-base rounded-md"
        (click)="emitSnackbarEvent('bulkAction',action)" *ngIf="action.showIf">
        {{ action?.displayKey ? (action?.displayKey | translate) : action?.displayName }}
      </button>
    </ng-container>
    <div class="inline-flex items-center ml-4">
      <button mat-icon-button disableRipple="true" aria-label="Clear Selection"
        (click)="emitSnackbarEvent('clearSelection')">
        <i class="ti ti-x text-lg"></i>
      </button>
    </div>
  </div>
</div>